import { getheaders } from "./authService";
import { toDateString } from "./JobService";

export async function getJobsPricing(startDate, endDate, region) {
    let requestOptions = {
        method: 'GET',
        headers: getheaders(),
        redirect: 'follow'
    };
    let params = `start_date=${toDateString(startDate)}&end_date=${toDateString(endDate)}`;
    if (region) params += `&region=${region}`;
    return fetch(`/api/pricing/jobs?${params}`, requestOptions);
}

export async function getJobPricing(cosJobId) {
    let requestOptions = {
        method: 'GET',
        headers: getheaders(),
        redirect: 'follow'
    };
    return fetch(`/api/pricing/jobs/${cosJobId}`, requestOptions);
}

export async function getPropertyPricing(startDate, endDate, region) {
    let requestOptions = {
        method: 'GET',
        headers: getheaders(),
        redirect: 'follow'
    };
    let params = `start_date=${toDateString(startDate)}&end_date=${toDateString(endDate)}`;
    if (region) params += `&region=${region}`;
    return fetch(`/api/pricing/properties?${params}`, requestOptions);
}

export async function getWorkOrders(startDate, endDate) {
    let requestOptions = {
        method: 'GET',
        headers: getheaders(),
        redirect: 'follow'
    };
    return fetch(`/api/worker/orders?start_date=${toDateString(startDate)}&end_date=${toDateString(endDate)}`, requestOptions);
}

export async function updateJobPricing(payload) {
    let requestOptions = {
        method: 'PUT',
        headers: getheaders(),
        redirect: 'follow',
        body: JSON.stringify(payload)
    };
    return fetch('/api/pricing/jobs', requestOptions);
}

export async function updatePropertyPricing(payload) {
    let requestOptions = {
        method: 'PUT',
        headers: getheaders(),
        redirect: 'follow',
        body: JSON.stringify(payload)
    };
    return fetch('/api/pricing/properties', requestOptions);
}

export async function issueInvoice(jobPriceList, groupType) {
    let requestOptions = {
        method: 'POST',
        headers: getheaders(),
        redirect: 'follow',
        body: JSON.stringify(jobPriceList)
    };
    return fetch(`/api/invoices?group_type=${groupType}`, requestOptions);
}

export async function isInvoiceInProgress() {
    let requestOptions = {
        method: 'GET',
        headers: getheaders(),
        redirect: 'follow'
    };
    return fetch('/api/invoices/progress', requestOptions);
}

export async function saveInvoicePDF(cosJobId) {
    let myHeaders = new Headers();
    myHeaders.append("Accept", "application/pdf");
    myHeaders.append("Content-Type", "application/pdf");
    myHeaders.append("Authorization", localStorage.getItem('cosToken'));
    let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`/api/invoices/pdf/${cosJobId}`, requestOptions);
}

export async function deleteJobFromInvoice(cosJobId) {
    let requestOptions = {
        method: 'PUT',
        headers: getheaders(),
        redirect: 'follow',
        body: JSON.stringify({})
    };
    return fetch(`/api/invoices/cancel/job/${cosJobId}`, requestOptions);
}

export async function getAllowedRegions() {
    let requestOptions = {
        method: 'GET',
        headers: getheaders(),
        redirect: 'follow'
    };
    return fetch('/api/user/allowedRegion', requestOptions);
}
